const page_current = () => {
	const nav = document.querySelector('.js-current-nav');
	if(nav !== null){
		const nav_height = nav.clientHeight;
		const sec_list = document.querySelectorAll('.js-current-nav__sec');
		const nav_btn = document.querySelectorAll('.l-current-page__side__list__item__btn');
		const header_height = window.innerWidth >= 768 ? 66 : nav_height;
		const header_height2 = window.innerWidth >= 768 ? 66 : nav_height+64;
		const nav_offset = window.pageYOffset + nav.getBoundingClientRect().top;

		nav.style.height =  nav_height+24+'px';

		// クリックでスクロール
		for (let i = 0; i < nav_btn.length; i++) {
			nav_btn[i].addEventListener('click', ()=>{
				let target = window.pageYOffset + sec_list[i].getBoundingClientRect().top - header_height2;
				window.scrollTo({top: target, behavior: 'smooth'});
			});
		}

		window.addEventListener('scroll', () => {
			let scroll = window.scrollY;
			let offset = window.innerHeight / 2;
			
			if(scroll > nav_offset - header_height){
				nav.closest('.l-current-page__side').classList.add('is-scroll');
			} else {
				nav.closest('.l-current-page__side').classList.remove('is-scroll');
			}

			// スクロールでカレント処理
			sec_list.forEach( (sec, index) => {
				let i = index + 1;
				let target = document.querySelector('.js-current-nav li:nth-of-type(' + i + ')');
				let pos = sec.getBoundingClientRect().top + scroll;
				if ( scroll > pos - offset ) {
					if (sec_list[i] !== undefined){
						let next_pos = sec_list[i].getBoundingClientRect().top + scroll;
						if ( scroll > next_pos - offset ) {
							target.classList.remove('is-current');
						} else if (target.classList.contains('is-current') == true) {
							return;
						} else if ( i == 1 ){
							target.classList.add('is-current')
						} else {
							target.classList.add('is-current');
						}
					} else {
						target.classList.add('is-current');
					}
				} else {
					target.classList.remove('is-current');
				}
			});

			
		});
	}
}